// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"73":"1459712d","226":"d3392c47","236":"0de2c19f","280":"bec74648","654":"33cb550f","658":"e8f328c6","680":"4dc5dc8c","915":"403491aa"}[chunkId] + ".css";
};